import { Component, ViewEncapsulation } from '@angular/core';
import * as Tone from 'tone';
import { MatSliderModule } from '@angular/material/slider';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DecimalPipe } from '@angular/common';
import { FormToggleComponent } from '../form-field/toggle.component';

@Component({
  selector: 'qa-volume-control',
  standalone: true,
  imports: [
    MatSliderModule,
    MatIconModule,
    TranslateModule,
    DecimalPipe,
    FormToggleComponent,
  ],
  templateUrl: './audio-volume.component.html',
  styleUrls: ['./audio-volume.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AudioVolumeComponent {
  private minVol = -20;

  get volume() {
    return 1 - Tone.getDestination().volume.value / this.minVol;
  }

  get muted() {
    return Tone.getDestination().mute === true;
  }

  toggleMute() {
    Tone.getDestination().mute = !Tone.getDestination().mute;
  }

  onVolumeChange(event: any) {
    const value = event.target.value;
    Tone.getDestination().volume.value = this.minVol * (1 - value);
    if (value === 0) {
      Tone.getDestination().mute = true;
    } else {
      Tone.getDestination().mute = false;
    }
  }
}
